<template>
  <div>
    <v-select
      v-model="item.id_modulo"
      :items="modulos"
      label="Modulos"
      outlined
      item-text="descricao"
      item-value="id"
    />

    <v-text-field
      v-model="item.descricao"
      label="Descrição do menu*"
      clearable
      autofocus
      outlined
    />

    <v-text-field
      v-model="item.url"
      label="Url do menu*"
      clearable
      outlined
    />

    <v-text-field
      v-model="item.icone"
      label="Icone do menu*"
      outlined
      :append-icon="item.icone"
      messages="Exemplo: mdi-home"
    />

    <TextFieldFormatadorDeValor
      v-model="item.ordem"
      label="Ordem do menu*"
      type="number"
      :maxDigitos="0"
      clearable
      outlined
      messages="Apenas números"
    />
  </div>
</template>

<script>
import { buscarModulosConfiguracaoMenuParametrizacao } from '../../../Api';
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";

export default {
  components: {
    TextFieldFormatadorDeValor
  },
  model: {
    prop: 'item',
    event: 'change-item'
  },
  props: {
    item: { type: Object },
    dialog: { type: Boolean },
  },
  data: () => ({
    modulos: []
  }),
  created() {
    setTimeout(() => this.buscarModulos(), 500);
  },
  watch: {
    dialog(valor) {
      if (valor) setTimeout(() => this.buscarModulos(), 500);
    }
  },
  methods: {
    buscarModulos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarModulosConfiguracaoMenuParametrizacao()
          .then((modulos) => this.modulos = modulos)
          .catch(() => this.Helpers.logout())
      )
    },
  }
}
</script>

<style>

</style>
